// ============================================================
// enterHome — open a portal on its pinned Home section (CLB-080 S5). Called only where the person
// enters a portal as a whole (the Home screen cards, the bar's portal name) — never when a specific
// section was asked for. The pin lives in this browser (navModel); a pinned section that no longer
// exists is ignored, so the portal opens on its default.
// ============================================================
import { PORTAL_NAV } from '../../constants/portals';
import { homeFor } from './navModel';

const FIELD = { developments: 'devView', sales: 'salesView', catalog: 'tab' };

/** setters: { setDevView, setSalesView, setTab } — returns true when a Home was applied. */
export function enterHome(portalKey, setters) {
  const field = FIELD[portalKey];
  const portal = PORTAL_NAV.find((p) => p.key === portalKey);
  if (!field || !portal) return false;
  // admin / Mail-Intelligence sections never count as a Home: the pin is per browser, not per person
  const valid = portal.subsections.filter((s) => !s.adminOnly && !s.miGated).map((s) => s[field]).filter(Boolean);
  const home = homeFor(portalKey, valid);
  if (!home) return false;
  if (portalKey === 'developments') setters.setDevView(home);
  else if (portalKey === 'sales') setters.setSalesView(home);
  else setters.setTab(home);
  return true;
}
